function openBillHandler({ metaItem, tplNode }) {
  const { metaProps } = metaItem;
  const baseMetaProps = (metaProps && JSON.parse(metaProps)) || {}
  if (metaItem.code === 'modalPadding') {
    baseMetaProps.showDesign = tplNode.params?.type === 'modal'
  }
  metaItem.metaProps = JSON.stringify(baseMetaProps)
}

export function designerManifest() {
  if (window.yyds && typeof window.yyds.on === 'function') {
    yyds.on(
      'beforeRenderPropMeta',
      ({ metaItem, tplNode }) => {
        openBillHandler({ metaItem, tplNode })
      },
      {
        libCodes: ['ynf-core-engine/actions/navigate'],
        controlTypes: ['openBill']
      }
    );
  }
}